import React from "react";

const TestimonialCard = ({ name, photo, quote, position }) => {
  return React.createElement(
    "div",
    { style: styles.card, className: "testimonial-card" },
    React.createElement("img", {
      src: photo,
      alt: `${name}'s photo`,
      style: styles.photo,
    }),
    React.createElement(
      "h3",
      { style: styles.name },
      name
    ),
    React.createElement(
      "h4",
      { style: styles.position },
      position // Add position here
    ),
    React.createElement(
      "p",
      { style: styles.quote },
      `"${quote}"`
    )
  );
};

const styles = {
  card: {
    background: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "16px",
    padding: "30px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    width: "350px",
    maxWidth: "90vw",
    margin: "10px",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  photo: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    objectFit: "cover",
    marginBottom: "15px",
  },
  name: {
    fontSize: "1.2rem",
    color: "#333",
    marginBottom: "5px",
  },
  position: {
    fontSize: "1rem",
    color: "#888",
    marginBottom: "20px",
    fontWeight: "500",
  },
  quote: {
    fontSize: "1.05rem",
    color: "#555",
    fontStyle: "italic",
    lineHeight: "1.7",
    flex: "1",
  },
};

export default TestimonialCard;